const scoresSelector = (state) => state.score.scores?.result ?? []

const solvencyScoreSelector = (state) => {
  const scores = state.score.scores?.result ?? []

  return (
    scores.find((s) => s?.type?.toLowerCase().includes('solvabilit')) ||
    scores[0]
  )
}

const scoreTimelineSelector = (state) => {
  const points = state.score.timeline?.result ?? []

  return [...points].sort((a, b) => new Date(a.date) - new Date(b.date))
}

export { scoresSelector, solvencyScoreSelector, scoreTimelineSelector }
